export const authenticate = (un, pw) => {
    return {
        type: 'AUTHENTICATE',
        payload: fetch(process.env.REACT_APP_API_HOST + 'api/auth/login', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                userName: un,
                password: pw
            }),
        }).then(res => {
            if (res.ok)
                return res.json();
            else
                return 'Invalid username or password.';
        })
    }
}

export const authenticateGoogle = (googleResponse) => {
    return {
        type: 'AUTHENTICATE',
        payload: fetch(process.env.REACT_APP_API_HOST + `api/auth/login`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                accessToken: googleResponse.tokenId,
                provider: 'google'
            }),
        }).then(res => {
            return res.json();
        })
    }
}

export const logout = dispatch => dispatch(logoutLocal);

const logoutLocal = () => { return { type: 'LOGOUT_LOCAL' } }

export const logoutAPI = () => {
    return {
        type: 'LOGOUT',
        payload: fetch(process.env.REACT_APP_API_HOST + `api/auth/logout`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.ok;
        })
    }
}


